<template>
  <div>
    <div class="timeline-left content-scroll-inner">
      <Timeline class="timeline-default timestamp-left tail-lg mt-10" v-if="auditItem && auditItem.length > 0">
        <div>
          <TimelineItem placement="top"
                        :class="getPackageType(_item.audit_type).color || 'dot-dark-blue'" v-for="(_item, index) in auditItem"
                        :name="index" :key="index">
            <Tooltip effect="dark" placement="bottom-start" class="pointer">
              <div slot="content" class="tooltipcontent">{{getPackageType(_item.audit_type).description}}</div>
              <div class="el-timeline-item__node el-timeline-item__node--normal">
                <svgicon :name="getPackageType(_item.audit_type).icon || 'icon-start-loading'" width="10" height="10" />
              </div>
            </Tooltip>
            <div class="el-timeline-item__timestamp is-top">
              <span class="date">{{ $moment(_item.date_time).format('MMM Do YY') }}</span>
              <span>{{ $moment(_item.date_time).format('LTS') }}</span>
            </div>
            <h4>{{ _item.details }}</h4>
            <p>{{ _item.performedBy }}</p>
          </TimelineItem>
        </div>
      </Timeline>
      <div v-else>
        <span>{{$t('INDENT_AUDIT_NOT_FOUND')}}</span>
      </div>
      <infinite-loading @infinite="loadAudit"  slot="append">
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { packingAudit } from '../../../constants/packing-audit';

export default {
  name: 'DeliveryDetails',
  props: ['deliveryId', 'orderNumber'],
  components: {},
  data() {
    return {
      auditItem: [],
      page: 1,
    };
  },
  computed: {
  },
  async created() {
    this.page = 1;
  },
  methods: {
    async loadAudit($state = null) {
      try {
        if (this.deliveryId && this.deliveryId.id) {
          const auditData = await this.$store.dispatch('order/fetchPackingAudit', {
            delivery: this.deliveryId && this.deliveryId.id,
            page: this.page,
          });
          if (auditData && auditData.length) {
            this.auditItem.push(...auditData);
            this.page += 1;
            $state.loaded();
          } else {
            $state.complete();
          }
        } else {
          $state.complete();
        }
      } catch (error) {
        $state.complete();
        this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    getPackageType(type) {
      const data = packingAudit && packingAudit.find(_type => _type.key === type);
      return data || {};
    },
  },
};

</script>
